import { productMapper } from '../../../mappers/productMapper';
import apiService from '../../../services/api-client';
import { DeleteArticleResponse } from '../interfaces/delete-article';
import { DeleteFileResponse } from '../interfaces/delete-file';
import { GetArticleResponse } from '../interfaces/get-article';
import { GetArticleParams, GetArticlesResponse } from '../interfaces/get-articles';
import { GetClassifiedArticleParams, GetClassifiedArticlesResponse } from '../interfaces/get-classified-articles';
import { PostArticlePayloadRequest, PostArticleResponse } from '../interfaces/post-article';
import { PutArticlePayloadRequest, PutArticleResponse } from '../interfaces/put-article';
import { Article } from '../../../interfaces/article.interface';

export const articlesApiService = {
  async getArticles(id: number, params: GetArticleParams) {
    // Soporte búsqueda por descripción
    if (params.description || params.code) {
      const { data } = await apiService().get<GetArticlesResponse>(`company/${id}/products`, {
        params: {
          description: params.description,
          code: params.code,
          page: params.page || 1,
          size: 20 // tamaño por defecto para resultados de búsqueda
        }
      });
      return data;
    }
    const { data } = await apiService().get<GetArticlesResponse>(`company/${id}/products`, {
      params
    });
    return data;
  },
  async getClassifiedArticles(id: number, params: GetClassifiedArticleParams) {
    const { data } = await apiService().get<GetClassifiedArticlesResponse>(`company/${id}/products/classified/lightweight`, {
      params
    });
    return data;
  },
  async getArticle(id: number, params: GetArticleParams) {
    const { data } = await apiService().get<GetArticleResponse>(`company/${id}/product/code/${params.code}`);
    return productMapper.mapResponseToProducts(data);
  },
  async postArticle(id: number, body: PostArticlePayloadRequest) {
    const { data } = await apiService().post<PostArticleResponse>(`company/${id}/product`, body);
    return data;
  },
  async postArticleFile(cId: number, pId: number, file: File) {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await apiService().post<PostArticleResponse>(`company/${cId}/product/${pId}/file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  },
  async putArticle(cId: number, pId: number, body: PutArticlePayloadRequest) {
    const { data } = await apiService().put<PutArticleResponse>(
      `company/${cId}/product/${pId}`,
      body
    );
    return data;
  },
  async deleteArticle(cId: number, pId: number) {
    const { data } = await apiService().delete<DeleteArticleResponse>(
      `company/${cId}/product/${pId}`
    );
    return data;
  },
  async deleteFile(cId: number, pId: number, fId: number) {
    const { data } = await apiService().delete<DeleteFileResponse>(
      `company/${cId}/product/${pId}/file/${fId}`
    );
    return data;
  },
};
